'use client'

import { Segmented } from 'antd'
import { SBDynamicFormInput } from './types'

const SBDynamicFormInputSegment: SBDynamicFormInput = ({ item, ...rest }) => {
  return (
    <Segmented
      {...rest}
      block
      options={item.options?.map((option) => ({
        value: option.id,
        label: option.label,
      }))}
    />
  )
}

export { SBDynamicFormInputSegment }
